import React, {useContext } from "react";
import { PJContext } from "./pj-context"
import {supFractions} from "../helpers";
import CONSTS from "./pj-constants";



function PJOrderSummaryBar(props) {
    const { state, dispatch, data } = useContext(PJContext);

    return  (
        <div className="order-summary">
            <div className="container">
                <div className="row">
                    <div className="col-sm-2 col-xs-5 order-sm-0 order-xs-1 my-auto">
                        <div className="go-back-button wp-block-button aligncenter is-style-outline">
                            <button className="wp-block-button__link has-text-color has-light-red-color arrow-back" onClick={e => dispatch({ type: CONSTS.CLOSE_JOURNEY}) }>Go back</button>
                        </div>
                    </div>

                    <div className="col-sm-8 order-sm-1 order-xs-0 col-xs-12 my-auto">
                        <div className="order-price flex-fill d-flex align-items-center">
                            <p className="cost-info d-flex mx-auto">
                                <span className="heading my-auto"><span>Your <strong>REV</strong> Order</span></span>
                                <span className="regular-price-amount my-auto">${data.price}</span>
                                <span className="vat-info">* prices exclude VAT</span>
                            </p>
                        </div>
                    </div>

                    <div className="col-sm-2 col-xs-5 order-xs-2 flex-xs-fill my-auto ml-xs-auto">
                        <div className="continue-button wp-block-button aligncenter is-style-outline has-white-background-color">
                            <button onClick={e => dispatch({ type: CONSTS.SET_STEP, args: {step: CONSTS.STEP_5b_PERSONAL_DETAILS} })} className="wp-block-button__link has-text-color has-light-red-color has-white-background-color">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export { PJOrderSummaryBar };